import { useAuth0 } from "@auth0/auth0-react";
import { useMemo, useEffect, useState } from "react";
import "./desktopSignoutRoute.css";

function DesktopSignoutRoute() {
  const { isAuthenticated, isLoading, logout, loginWithRedirect, error } =
    useAuth0();
  const done = useMemo(
    () => new URLSearchParams(window.location.search).get("done") === "1",
    [],
  );
  console.log("SIGNOUT ROUTE ----->", { done, isAuthenticated, isLoading });

  const [probing, setProbing] = useState(!done);

  useEffect(() => {
    if (isLoading) return;
    if (done || isAuthenticated || error) {
      setProbing(false);
      return;
    }
    if (sessionStorage.getItem("ds-silent-attempted") === "1") {
      setProbing(false);
      return;
    }
    sessionStorage.setItem("ds-silent-attempted", "1");
    // Leave probing=true; we're about to navigate away.
    loginWithRedirect({
      authorizationParams: {
        prompt: "none",
        redirect_uri: window.location.origin + "/desktop-signout",
      },
    }).catch(() => setProbing(false));
  }, [isLoading, done, isAuthenticated, error, loginWithRedirect]);

  const handleBrowserSignOut = () => {
    logout({
      logoutParams: {
        returnTo: window.location.origin + "/desktop-signout?done=1",
      },
    });
  };

  const closeTab = () => window.close();

  let body;
  if (isLoading || probing) {
    body = (
      <>
        <h1 className="ds-title">Signing you out…</h1>
        <div className="ds-spinner" aria-hidden="true" />
      </>
    );
  } else if (done || !isAuthenticated) {
    body = (
      <>
        <h1 className="ds-title">You've been signed out.</h1>
        <p className="ds-body">
          You're signed out of OverWatch on this device and in this browser. You
          can safely close this tab.
        </p>
      </>
    );
  } else {
    body = (
      <>
        <h1 className="ds-title">Signed out of the desktop app.</h1>
        <p className="ds-body">
          You're still signed into OverWatch in this browser. Sign out here if
          you'd like to switch accounts next time in the desktop app or the
          browser, or end your browser session.
        </p>
        <div className="ds-actions">
          <button
            type="button"
            className="ds-btn ds-btn--primary"
            onClick={handleBrowserSignOut}
          >
            Sign Out From Browser
          </button>
        </div>
      </>
    );
  }

  return (
    <div className="ds-screen">
      <div className="ds-card">
        <img
          src="/svgs/4Sight_Labs_Logo_White.svg"
          alt="OverWatch"
          className="ds-logo"
        />
        <p className="ds-eyebrow">OverWatch</p>
        {body}
      </div>
    </div>
  );
}

export default DesktopSignoutRoute;
